// extracted by mini-css-extract-plugin
module.exports = {"container":"Y5gE_26XQkDNnAZXIZ1Pg"};